export default {
  name: "History",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M29 16.4c0 7.22-5.83 13.1-13 13.1S3 23.62 3 16.4c0-2.9 1.44-5.82 1.51-5.95.25-.49.85-.69 1.34-.45a1 1 0 0 1 .45 1.34c-.02.03-1.3 2.64-1.3 5.06 0 6.12 4.94 11.1 11 11.1s11-4.98 11-11.1a11.06 11.06 0 0 0-16.04-9.89l1.64.26a1 1 0 0 1-.16 1.98l-.16-.01-4.14-.65a1.01 1.01 0 0 1-.77-1.37l1.7-4.1a1 1 0 0 1 1.85.77l-.48 1.16A12.79 12.79 0 0 1 16 3.3c7.17 0 13 5.88 13 13.1zM16 9.5a1 1 0 0 0-1 1v7a1 1 0 0 0 .63.93l5 2a1 1 0 0 0 1.3-.56c.2-.51-.05-1.09-.56-1.3L17 16.82V10.5a1 1 0 0 0-1-1z",
  },
}
